<template>
  <!--==========================
    Call To Action Section
  ============================-->
  <section id="call-to-action">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-9 text-center">
          <h3 class="cta-title">Get in touch and tell me about your business</h3>
          <a href="#contact" class="cta-btn align-middle" @click.prevent="scrollToContact">
            Contact Us
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "CallToAction",
  methods: {
    scrollToContact() {
      const el = document.querySelector("#contact");
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
};
</script>
